import { Link } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';

import { LegalDocumentScreen } from '@/src/features/legal/LegalDocumentScreen';
import { termsOfService } from '@/src/features/legal/legal-documents';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

export default function TermsScreen() {
  return (
    <LegalDocumentScreen
      document={termsOfService}
      afterContent={
        <View style={styles.policyCallout}>
          <Text style={styles.policyTitle}>Verified account refunds</Text>
          <Text style={styles.policyText}>
            Frienzzi publishes a standalone Refund Policy for the optional
            verified account processing fee, including when the fee can be
            refunded before Stripe Identity starts and when it is generally
            non-refundable after identity verification starts.
          </Text>
          <Link href="/refund-policy" style={styles.policyLink}>
            Read the Refund Policy
          </Link>
        </View>
      }
    />
  );
}

const styles = StyleSheet.create({
  policyCallout: {
    backgroundColor: colors.surfaceTint,
    borderColor: colors.primary,
    borderRadius: 8,
    borderWidth: 1,
    gap: spacing.sm,
    padding: spacing.lg,
  },
  policyLink: {
    color: colors.primary,
    fontSize: 15,
    fontWeight: '900',
  },
  policyText: {
    color: colors.text,
    fontSize: 15,
    lineHeight: 22,
  },
  policyTitle: {
    color: colors.text,
    fontSize: 17,
    fontWeight: '900',
  },
});
